import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { CurrentUserModule } from '®shared/current-user';

import { DashboardAnalyticsService } from './dashboard-analytics.service';

@NgModule({
  imports: [CommonModule, CurrentUserModule, HttpClientModule],
  providers: [DashboardAnalyticsService],
})
export class DashboardAnalyticsModule {}
